"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _uniqueIdHelper = require("./unique-id-helper");

var _each = _interopRequireDefault(require("lodash/each"));
/**
 * Post messsage helper, can be used to communicate when your inside a iframe
 * your can bind your callbacks on a specified event "type"
 * make sure to call clear on compontentWillUnmount !
 *
 * @class PostMessageHelper
 */


var PostMessageHelper = /*#__PURE__*/function () {
  function PostMessageHelper() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, PostMessageHelper);

    this.handleMessage = function (event) {
      var instance = _this;

      if (!event || !event.data || !event.data.type) {
        return;
      }

      try {
        var handlers = _this.getHandlersForMessageType(event.data.type);

        if (handlers.length > 0) {
          (0, _each["default"])(handlers, function (handler) {
            // Invoke the handler
            try {
              handler.handler.apply(instance, [event.data]);
            } catch (handlerException) {
              console.error(handlerException);
            }
          });
        }
      } catch (e) {
        console.error(e);
      }
    };

    this.handlers = {}; // Attach the post message listener

    window.addEventListener('message', this.handleMessage);
  }

  (0, _createClass2["default"])(PostMessageHelper, [{
    key: "createPostMessageAPITunnel",
    value: function createPostMessageAPITunnel(key, successCallback) {
      var errorCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console.error;
      this.bind("".concat(key, "_RESPONSE"), successCallback);
      this.bind("".concat(key, "_ERROR"), errorCallback);
      window && window.top && window.top.postMessage({
        type: key
      }, '*');
    }
    /**
     * bind to a post message for a specified type
     *
     * @param {any} type - specified type
     * @param {any} handler - callback will be called when a event is received from the specified type
     * @returns null
     *
     * @memberOf PostMessageHelper
     */

  }, {
    key: "bind",
    value: function bind(type, handler) {
      // Make sure the name and handler are valid
      if (typeof type !== 'string') {
        throw new TypeError('A valid message type should be specified.');
      }

      if (typeof handler !== 'function') {
        throw new TypeError('A valid function should be specified as the handler for a message with this type.');
      } // Create the new handler


      var newHandler = {
        id: (0, _uniqueIdHelper.generateGuid)(),
        handler: handler
      }; // Get the existing handler and push the new one

      var existingHandlers = this.getHandlersForMessageType(type);
      existingHandlers.push(newHandler); // Store all the handlers again

      this.handlers[type] = existingHandlers; // Return the new handler id so the user can unbind the handler

      return newHandler.id;
    }
    /**
     * clear all handlers, call this method during compontentWillUnmount
     *
     *
     * @memberOf PostMessageHelper
     */

  }, {
    key: "clear",
    value: function clear() {
      this.handlers = {};
      window.removeEventListener('message', this.handleMessage);
    }
    /**
     * get callback for this specified type
     *
     * @param {any} type - name of the event type
     * @returns callback if available
     *
     * @memberOf PostMessageHelper
     */

  }, {
    key: "getHandlersForMessageType",
    value: function getHandlersForMessageType(type) {
      // Make sure the name and handler are valid
      if (typeof type !== 'string') {
        throw new TypeError('A valid message type should be specified.');
      }

      return this.handlers[type] || [];
    }
    /**
     * Handler message from the brower event binder, check if some handler is subscripted to this event
     *
     * @param {any} event - message event from the browser
     *
     * @memberOf PostMessageHelper
     */

  }]);
  return PostMessageHelper;
}();

var _default = PostMessageHelper;
exports["default"] = _default;